import * as React from "react";
import { Link } from "react-router";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import translate from "react-i18next/dist/commonjs/translate";
import * as _roles from "../authorization/roles";

class NavMenu extends React.Component {
  DASHBOARD_ROLES = _roles.DASHBOARD_ROLES;
  REPORT_ROLES = _roles.REPORT_ROLES;
  
  render() {
    let { t, customerInformation } = this.props;
    const roles  = _roles.RolesfromToken(this.props.oidc.user.access_token);
    return (
      <nav className="navbar navbar-default">
        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-7">
          <ul className="nav navbar-nav text-center">
            {roles != null && this.DASHBOARD_ROLES.some((allowed) =>
              roles.includes(allowed)) && 
              (<li>
                <Link
                  to={`${global.applicationPath}/`}
                  activeClassName="active">
                  {t("dashboard")}
                </Link>
              </li>
            )}
            <li>
              <Link
                to={`${global.applicationPath}/log-sources`}
                activeClassName="active">
                {t("myNodes")}
              </Link>
            </li>
            <li>
              <Link
                to={`${global.applicationPath}/incidents`}
                activeClassName="active">
                {t("incidents")}
              </Link>
            </li>
            {roles != null && this.REPORT_ROLES.some((allowed) => roles.includes(allowed)) && (
              <li>
                <Link
                  to={`${global.applicationPath}/reports`}
                  activeClassName="active">
                  {t("reports")}
                </Link>
              </li>
            )}
            <li>
              <Link
                to={`${global.applicationPath}/support`}
                activeClassName="active">
                {t("support")}
              </Link>
            </li>
            <li className="technicalAnalysis">
              <a
                href={customerInformation.technicalAnalysisUrl}
                target="_blank">
                <i className="fa fa-1 fa-sign-in" /> {t("technicalAnalysis")}
              </a>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

NavMenu.propTypes = {
  customerInformation: PropTypes.object.isRequired,
  oidc: PropTypes.object.isRequired,
  t: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    customerInformation: state.customerInformation,
    oidc: state.oidc,
  };
};

export default translate("translations")(
  connect(mapStateToProps, null)(NavMenu)
);



// WEBPACK FOOTER //
// ./src/navigation/NavMenu.js